import { useBenefitCategories, useBenefits } from '../../../app-init-data';

type PlanAllBenefitSchema = {
	benefitCategoryTitle: string;
	benefitCategoryId: number;
	subBenefits: {
		id: number;
		title: string;
		description: string;
	}[];
};

type BenefitSchema = {
	benefitCategoryId: number;
	code: string;
	description: string;
	id: number;
	name: string;
}[];

export type PlanBenefits = {
	benefitId: number;
}[];

export const usePlanAllBenefits = (planBenefits: PlanBenefits) => {
	const { groupByBenefitCategoryId } = useBenefits();
	const { getBenefitCategoryById } = useBenefitCategories();

	const transformedBenefits: PlanAllBenefitSchema[] = [];

	const transformBenefits = (groupedBenefit: BenefitSchema) => {
		groupedBenefit.forEach((benefitItem) => {
			if (planBenefits.some((planItem) => planItem.benefitId === benefitItem.id)) {
				const categoryIndex = transformedBenefits.findIndex(
					(b) => b.benefitCategoryId === benefitItem.benefitCategoryId
				);

				if (categoryIndex !== -1) {
					transformedBenefits[categoryIndex].subBenefits.push({
						id: benefitItem.id,
						title: benefitItem.name,
						description: benefitItem.description,
					});
				} else {
					transformedBenefits.push({
						benefitCategoryId: benefitItem.benefitCategoryId,
						benefitCategoryTitle: getBenefitCategoryById(benefitItem.benefitCategoryId)?.name ?? '',
						subBenefits: [
							{
								id: benefitItem.id,
								title: benefitItem.name,
								description: benefitItem.description,
							},
						],
					});
				}
			}
		});
	};

	for (const key in groupByBenefitCategoryId) {
		transformBenefits(groupByBenefitCategoryId[key]);
	}

	return transformedBenefits;
};
